import React from 'react';
import PropTypes from 'prop-types';
import buildClassNames from 'classnames';
import './Blocks.scss';

const Blocks = ({ children, hasDivider, hasWrap, count }) => (
    <div
        className={buildClassNames('blocks', {
            'blocks--divider': hasDivider,
            [`blocks--${count}up`]: count,
            'blocks--wrap': hasWrap,
        })}>
        {children}
    </div>
);

Blocks.propTypes = {
    children: PropTypes.node.isRequired,
    hasDivider: PropTypes.bool.isRequired,
    hasWrap: PropTypes.bool.isRequired,
    count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default Blocks;
